import { useEffect } from 'react';

export const useScrollLock = (lock: boolean) => {
  useEffect(() => {
    if (lock) {
      // Save the current scroll position
      const scrollPosition = window.scrollY;

      // Add styles to prevent scrolling
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = '100%';
    } else {
      // Get the scroll position from the body's top property
      const scrollPosition = document.body.style.top;

      // Remove the styles that prevent scrolling
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';

      // Restore the scroll position
      if (scrollPosition) {
        window.scrollTo(0, parseInt(scrollPosition.slice(1)) || 0);
      }
    }
  }, [lock]);
};
